import { Dispatch, SetStateAction, useCallback, useState } from "react";

export interface DownloadCsvModalController {
  show: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  open: () => void;
}

export const useDownloadCsvModalController = (): DownloadCsvModalController => {
  const [show, setShowModal] = useState(false);

  const open = useCallback(() => {
    setShowModal(true);
  }, []);

  return {
    show,
    setShowModal,
    open,
  };
};
